/**
 * Detects the WebKit engine: Safari, iOS WebViews and every iOS browser (Chrome on iOS
 * reports "CriOS"). Blink browsers also send "AppleWebKit" in their user agent, so they're
 * excluded by their own tokens.
 */
export function getIsWebkit(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    /AppleWebKit/i.test(navigator.userAgent) &&
    !/(?:Chrome|Chromium|Edg|OPR)\//i.test(navigator.userAgent)
  );
}
